import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { AdminDashboard } from './AdminDashboard';
import { UserManagement } from './UserManagement';
import { RoleManagement } from './RoleManagement';
import { PaymentManagement } from './PaymentManagement';
import ContentManagement from './ContentManagement';
import ThemeManagement from './ThemeManagement';
import EmailManagement from './EmailManagement';
import NotificationManagement from './NotificationManagement';
import SystemSettings from './SystemSettings';
import { useRbac } from '../../context/RbacContext';

// Import other admin components (you'll need to create these)
import { InventoryManagement } from '../inventory/InventoryManagement';
import { OrderManagement } from '../orders/OrderManagement';
import { CustomerManagement } from '../customers/CustomerManagement';
import { QualityControlManagement } from '../quality-control/QualityControlManagement';
import { MaintenanceManagement } from '../maintenance/MaintenanceManagement';
import { ProductionLineManagement } from '../production/ProductionLineManagement';
import { ProductionOperationsHub } from '../production/ProductionOperationsHub';
import { WorkOrderDetail } from '../production/WorkOrderDetail';
import { MachineFloor } from '../production/MachineFloor';
import { ProductionQueue } from '../production/ProductionQueue';
import { WarehouseManagement } from '../warehouse/WarehouseManagement';
import { DeliveryManagement } from '../delivery/DeliveryManagement';
import { FinancialDashboard } from '../financials/FinancialDashboard';
import { SupplyChainManagement } from '../supply-chain/SupplyChainManagement';
import { ReportGenerator } from '../reports/ReportGenerator';
import { ProductManagement } from '../products/ProductManagement';
import { ProductConfiguratorWrapper } from '../products/ProductConfiguratorWrapper';
import { ProductDisplayWrapper } from '../products/ProductDisplayWrapper';
import LoaderDemo from '../common/LoaderDemo';

const AdminRoutes: React.FC = () => {
  const { hasPermission } = useRbac();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Routes>
        {/* Dashboard */}
        <Route 
          path="dashboard" 
          element={<AdminDashboard />}
        />
        
        {/* User Management */}
        <Route 
          path="users" 
          element={<UserManagement />}
        />
        
        <Route 
          path="roles" 
          element={<RoleManagement />}
        />
        
        {/* System Management */}
        <Route 
          path="settings" 
          element={<SystemSettings />}
        />
        
        <Route 
          path="content" 
          element={<ContentManagement />}
        />
        
        <Route 
          path="theme" 
          element={<ThemeManagement />}
        />
        
        <Route 
          path="email" 
          element={<EmailManagement />}
        />
        
        <Route 
          path="notifications" 
          element={<NotificationManagement />}
        />
        
        {/* Business Operations */}
        <Route 
          path="production/operations" 
          element={<ProductionOperationsHub />}
        />

        <Route 
          path="production/work-orders/:id" 
          element={<WorkOrderDetail />}
        />

        <Route 
          path="production/machines" 
          element={<MachineFloor />}
        />

        <Route 
          path="production/queue" 
          element={<ProductionQueue />}
        />

        <Route 
          path="production" 
          element={<ProductionLineManagement />}
        />

        <Route 
          path="warehouse" 
          element={<WarehouseManagement />}
        />

        <Route 
          path="deliveries" 
          element={<DeliveryManagement />}
        />

        <Route 
          path="financials" 
          element={<FinancialDashboard />}
        />
        
        <Route 
          path="inventory" 
          element={<InventoryManagement />}
        />
        
        <Route 
          path="orders" 
          element={<OrderManagement />}
        />
        
        <Route 
          path="customers" 
          element={<CustomerManagement />}
        />
        
        <Route 
          path="quality" 
          element={<QualityControlManagement />}
        />
        
        <Route 
          path="maintenance" 
          element={<MaintenanceManagement />}
        />
        
        <Route 
          path="supply-chain" 
          element={<SupplyChainManagement />}
        />
        
        {/* Product Management */}
        <Route 
          path="products" 
          element={<ProductManagement />}
        />
        
        <Route 
          path="products/configurator/:productId" 
          element={<ProductConfiguratorWrapper />}
        />
        
        <Route 
          path="products/display/:productId" 
          element={<ProductDisplayWrapper />}
        />
        
        {/* Financial Management */}
        <Route 
          path="payments" 
          element={<PaymentManagement />}
        />
        
        <Route 
          path="invoices" 
          element={<PaymentManagement />}
        />
        
        <Route 
          path="bank-payments" 
          element={<PaymentManagement />}
        />
        
        <Route 
          path="mpesa" 
          element={<PaymentManagement />}
        />
        
        {/* Analytics & Reports */}
        <Route 
          path="analytics" 
          element={<AdminDashboard />}
        />
        
        <Route 
          path="reports" 
          element={<ReportGenerator />}
        />
        
        <Route 
          path="performance" 
          element={<AdminDashboard />}
        />
        
        {/* Loader Demo */}
        <Route 
          path="loader-demo" 
          element={<LoaderDemo />}
        />
        
        {/* Default route */}
        <Route 
          path="/" 
          element={<Navigate to="dashboard" replace />}
        />
        
        {/* Fallback route */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </Box>
  );
};

export default AdminRoutes; 